import { DEFAULT_FIELD_MAX_LENGTH } from '@coaf-library/IO/db';
import { isObject } from '@coaf-library/helpers/helperFunctions';

export function checkValidity(val: unknown): boolean {
  if (Array.isArray(val)) return val.length > 0;
  if (isObject(val)) return Object.keys(val).length > 0;
  return val !== undefined && val !== null && val !== '';
}

export function isWithinMaxLength(val: unknown, maxLength?: number | null): boolean {
  const length = getStringLength(val);
  return length === undefined || length <= (maxLength ?? DEFAULT_FIELD_MAX_LENGTH);
}

function getStringLength(val: unknown): number | undefined {
  if (typeof val === 'string') return val.length;
  if (Array.isArray(val)) {
    return val.reduce((total, item) => {
      return typeof item === 'string' ? total + item.length : total;
    }, 0);
  }
  return undefined;
}
